import { bootstrapApplication } from '@angular/platform-browser';

import * as amplitude from '@amplitude/analytics-browser';
import { sessionReplayPlugin } from '@amplitude/plugin-session-replay-browser';
import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';
import { ENVIRONMENT } from '@instaclause-webapp/shared-core';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    const env = appRef.injector.get(ENVIRONMENT);
    const version = env.version;
    if (version) {
      console.log(`App version: ${version}`);
    }

    const sessionReplayTracking = sessionReplayPlugin({
      sampleRate: 1,
      privacyConfig: {
        defaultMaskLevel: 'medium',
        unmaskSelector: [
          '.cc-toolbar',
          '.cc-sidebar-nav',
          '.cc-header',
          '.cc-bottom',
        ],
      },
    });
    amplitude.add(sessionReplayTracking);
    amplitude.init(env.amplitudeApiKey, { autocapture: true });

    if (env.faroUrl) {
      initializeFaro({
        url: env.faroUrl,
        app: {
          name: 'Webapp',
          version: version,
          environment: env.production ? 'production' : 'staging',
        },

        instrumentations: [
          // Mandatory, omits default instrumentations otherwise.
          ...getWebInstrumentations(),

          // Tracing package to get end-to-end visibility for HTTP requests.
          new TracingInstrumentation(),
        ],
      });
    }
  })
  .catch((err) => console.error(err));
